/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Dialog from "../../../shared/dialog";
import "./index.scss";
import MyButton from "../../../shared/buttons/primary";
import { cloneDeep } from "lodash";

const CustomerDialog = (props) => {
  const { detailData, show, onclose } = props;
  const [formUpdate, setFormUpdate] = React.useState({
    phone_number: "",
    memo: "",
    shop: window.store.getState().auth.user.id,
    actual_visit_count: "",
  });
  const [disableBtn, setDisableBtn] = React.useState(false);

  React.useEffect(() => {
    if (detailData) {
      let formInit = {};
      const fields = ["phone_number", "actual_visit_count", "memo"];
      fields.forEach((field) => {
        formInit[field] = detailData[field] ?? "";
      });
      setFormUpdate({ ...formUpdate, ...formInit });
    }
  }, [detailData]);

  const handleChangeForm = (name, value) => {
    setFormUpdate({
      ...formUpdate,
      [name]: value,
    });
  };

  const onCloseRequest = (data) => {
    onclose(data);
  };

  const handleUpdateCustomer = async () => {
    setDisableBtn(true);
    const formSubmit = cloneDeep(formUpdate);
    handleUpdate(formSubmit);
  };

  const handleUpdate = (formSubmit) => {
    window
      .axios({
        url: `user/${detailData.id}/update_stats/`,
        method: "patch",
        data: formSubmit,
      })
      .then((result) => {
        onCloseRequest(result.data);
      });
  };

  return (
    <Dialog
      id="menu-dialog"
      className={"booking-dialog menu-dialog"}
      title={"追加"}
      isShow={!!show}
      onCloseRequest={() => onCloseRequest({})}
      closeOnOverlayClick={false}
    >
      <div className="booking-form__row required">
        <div className="booking-form__label">
          <label className="form-label user-select-none">電話番号</label>
        </div>
        <div className="booking-form__control">
          <input
            className="form-control"
            placeholder="電話番号"
            maxLength="11"
            inputMode="tel"
            value={formUpdate.phone_number}
            name="phone_number"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            onChange={(e) =>{
              const { value } = e.target;
              handleChangeForm("phone_number", value);
            }}
          />
        </div>
      </div>
      <div className="booking-form__row required">
        <div className="booking-form__label">
          <label className="form-label user-select-none">予約回数</label>
        </div>
        <div className="booking-form__control">
          <input
            type="number"
            className="form-control"
            placeholder="予約回数"
            inputMode="decimal"
            value={formUpdate.actual_visit_count}
            name="actual_visit_count"
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            onChange={(e) => {
              const { value } = e.target;
              handleChangeForm("actual_visit_count", value);
            }}
          />
        </div>
      </div>
      <div className="booking-form__row required">
        <div className="booking-form__label">
          <label htmlFor="customerNote" className="form-label user-select-none">
            メモ
          </label>
        </div>
        <div className="booking-form__control">
          <textarea
            className="form-control resize-none outline-none"
            rows="3"
            value={formUpdate.memo}
            name="memo"
            maxLength="200"
            placeholder="メモ"
            onChange={(e) => {
              const { value } = e.target;
              handleChangeForm("memo", value);
            }}
          />
        </div>
      </div>
      <div className="booking-form__btns">
        <MyButton
          myVariant="cancel"
          disabled={disableBtn}
          onClick={() => onCloseRequest({})}
        >
          キャンセル
        </MyButton>
        <MyButton
          myVariant="edit"
          isLoading={disableBtn}
          onClick={handleUpdateCustomer}
        >
          保存
        </MyButton>
      </div>
    </Dialog>
  );
};

export default React.memo(CustomerDialog);
